import styled from 'styled-components';

export const HelpModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 1.45rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 9500;
  max-width: 500px;
  width: 90%;
`;

export const HelpModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9400;
`;

export const HelpModalTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e1e1e;
  margin: 0 0 0.97rem 0;
  padding-right: 1.45rem;
`;

export const HelpModalContent = styled.div`
  font-size: 0.875rem;
  color: #666;
  line-height: 1.5;
`;

export const HelpModalClose = styled.button`
  position: absolute;
  top: 0.97rem;
  right: 0.97rem;
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0.387rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }
`; 